/* ==========================================================================
   NR - RECOMENDADOS EN EL CARRITO
   v1 16-10-2026 (recomendaciones automaticas)
   v5 16-10-2026 (familia del perfume + TOP VENTAS de relleno)

   PARA QUE: subir el pedido medio. En España el pedido medio es 59,01 € y el
   envio gratis por importe esta en 80 €. Faltan 21 €.

   -------------------------------------------------------------------------
   QUE ENSEÑA, Y EN QUE ORDEN

   1) LO DE SU MISMA FAMILIA. Si lleva KHAMRAH, se le ofrece el PACK KHAMRAH,
      la BRUMA CORPORAL KHAMRAH, el AMBIENTADOR, el DESODORANTE... Si lleva
      YARA, los packs de Yara, la crema, el roll on, el aceite. Igual con
      ASAD BOURBON, TERIAQ, NOBLE BLUSH y cualquier otra linea.
      Los COMPLEMENTOS van primero (pack, bruma, ambientador, desodorante,
      crema, aceite, roll on) y despues los demas perfumes de la familia.
   2) Si no se llenan los 6 huecos, se rellena con la coleccion TOP VENTAS,
      en su orden MANUAL. Ese orden se cambia arrastrando en Shopify:
      Productos > Colecciones > TOP VENTAS. No hay que tocar este fichero.
   3) Si todo lo anterior fallara, recomendaciones automaticas de Shopify.

   La familia se saca de la primera palabra con fundamento del titulo del
   articulo mas caro del carrito, y se busca con el buscador de la tienda.

   -------------------------------------------------------------------------
   DOS TRAMPAS QUE COSTARON SENDOS FALLOS (las dos comprobadas en la tienda)

   A) EL PRECIO VIENE EN DOS FORMATOS DISTINTOS segun el endpoint:
        /recommendations/products.json  ->  4000     (centimos, numero)
        /collections/X/products.json    ->  "40.00"  (euros, TEXTO)
      En la v4 el filtro comparaba "40.00" < 1500 y daba VERDADERO, asi que
      descartaba TODOS los productos como si fueran muestras: el carrusel no
      aparecia. Por eso aqui los candidatos SIEMPRE se resuelven con
      /products/<handle>.js, que devuelve centimos en numero, siempre.

   B) EL FILTRO ANTI-MUESTRAS NO PUEDE SER UN PRECIO MINIMO A SECAS.
      Hace falta descartar la muestra de 5 ml cuando el frasco esta agotado
      (si no, a quien lleva 45 € se le ofreceria una muestra de 5,50 €).
      Pero los complementos son BARATOS DE VERDAD:
        DESODORANTE KHAMRAH    6,00 €
        AMBIENTADOR KHAMRAH   11,00 €
        BRUMA CORPORAL        12,50 €
        Roll on Yara rosa      5,00 €
      Un minimo de 15 € los habria matado a todos.
      Regla correcta: se descarta el producto solo si su variante MAS CARA
      (este o no disponible) llega a 15 € PERO la mejor DISPONIBLE no llega.
      Eso significa "el frasco esta agotado y solo queda la muestra". Si el
      producto es barato de por si, se queda.
   -------------------------------------------------------------------------

   Reglas que no cambian:
   - Nunca ofrece algo que ya este en el carrito.
   - De cada producto ofrece la variante disponible MAS CARA (el frasco), y
     pinta ESE precio. Nunca el de la muestra.
   - Si algo falla, no pinta nada. El carrito nunca se rompe por esto.
   - Al añadir usa el parametro "sections", que es como refresca Dawn su
     propio cajon. Con /cart/add.js a secas el cajon se queda con el
     contenido viejo y el boton de pagar sale desactivado.

   Revertir: borrar el bloque de nr-recomendados de
   snippets/nr-variante-principal.liquid
   ========================================================================== */
(function () {
  'use strict';

  var COLECCION     = 'top-ventas';
  var UMBRAL_FRASCO = 1500;   // 15,00 €: por encima es frasco, no muestra
  var MAX_TARJETAS  = 6;
  var MAX_CONSULTAS = 14;     // tope de fichas que se piden, por velocidad

  /* Marcas: se quitan del titulo antes de buscar. Si no, "Lattafa" casaria
     con media tienda. */
  var MARCAS = ['lattafa','armaf','afnan','nusuk','rayhaan','french avenue','maison alhambra',
                'fragrance world','al haramain','swiss arabian','emper','le chameau','dumont',
                'paris','ard al zaafaran','khadlaj','orientica','zimaya','riiffs','asdaaf'];

  /* Palabras que describen CUALQUIER perfume y por tanto no sirven para saber
     si dos productos son de la misma linea. Comprobado el 16-10-2026: sin esta
     lista, "TERIAQ INTENSE" se traia los CLUB DE NUIT INTENSE por compartir la
     palabra "intense", que no tienen nada que ver. */
  var DESCRIPTORES = ['intense','intensely','elixir','extrait','parfum','perfume','eau','edp','edt',
                      'limited','edition','special','collection','coleccion','man','woman','men','women',
                      'homme','femme','noir','black','blanco','white','gold','golden','blue','azul','red',
                      'rouge','rosa','pink','oud','sport','night','day','aniversario','gift','original',
                      'nuevo','nueva','unisex','hombre','mujer','arabe','para'];

  /* Palabras que NO identifican una familia: si el titulo empieza por una de
     estas (porque el propio articulo es un pack o un complemento), se pasa a
     la siguiente palabra. */
  var GENERICAS = ['pack','ambientador','desodorante','bruma','crema','roll','on','aceite','set','coffret',
                   'eau','de','la','el','los','las','gift','en','para','kit','estuche','recambio','muestra',
                   'mini','miniaturas',
                   // 16-10-2026, comprobado: sin estas, "BRUMA CORPORAL KHAMRAH" daba
                   // familia "CORPORAL" y "CREMA HIDRATANTE YARA" daba "HIDRATANTE".
                   'corporal','hidratante','perfumado','perfumada','body','mist','spray','locion','gel'];

  /* Lo que cuenta como complemento: va primero en el carrusel. */
  var RE_COMPLEMENTO = /\b(pack|ambientador|desodorante|bruma|crema|aceite|roll\s?on|set|coffret|gift|estuche|kit)\b/i;

  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var pintando = false;
  var firmaActual = '';

  function dinero(centimos) {
    return (centimos / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function firmaDe(carrito) {
    return carrito.items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',');
  }

  /* Primera palabra con fundamento del titulo. "KHAMRAH Lattafa" -> KHAMRAH;
     "PACK ASAD BOURBON Lattafa" -> ASAD; "YARA ROSA Lattafa" -> YARA. */
  function familiaDe(titulo) {
    var palabras = String(titulo || '')
      .replace(/[^\p{L}\p{N}\s]/gu, ' ')
      .split(/\s+/)
      .filter(Boolean);
    for (var i = 0; i < palabras.length; i++) {
      var p = palabras[i];
      if (p.length < 3) continue;
      if (GENERICAS.indexOf(p.toLowerCase()) !== -1) continue;
      return p;
    }
    return '';
  }

  /* Quita la marca y devuelve las palabras con las que SI se puede saber si
     dos productos son de la misma linea. Se cae la marca, los genericos
     (pack, ambientador...) y los descriptores (intense, elixir...). */
  function distintivos(titulo) {
    var s = ' ' + String(titulo || '').toLowerCase() + ' ';
    MARCAS.forEach(function (m) { s = s.split(m).join(' '); });
    return s.replace(/[^\p{L}\p{N}\s]/gu, ' ')
      .split(/\s+/)
      .filter(function (w) {
        return w.length >= 4 &&
               GENERICAS.indexOf(w) === -1 &&
               DESCRIPTORES.indexOf(w) === -1;
      })
      .filter(function (w, i, a) { return a.indexOf(w) === i; });
  }

  /* Cuantas palabras distintivas comparten dos titulos. 0 = no son familia. */
  function comparten(a, b) {
    var n = 0;
    a.forEach(function (w) { if (b.indexOf(w) !== -1) n++; });
    return n;
  }

  /* Texto de busqueda: el titulo sin la marca. Devuelve tambien una segunda
     consulta con las dos ultimas palabras distintivas, que es lo que rescata
     los complementos de una sublinea.
     Caso real: "BADEE AL OUD NOBLE BLUSH" buscado entero devuelve los ocho
     BADEE AL OUD y se deja fuera "PACK NOBLE BLUSH" y "Ambientador Noble
     Blush", que es justo lo que hay que ofrecer. Buscando "noble blush"
     aparte, salen. */
  function consultas(titulo) {
    var d = distintivos(titulo);
    if (!d.length) return [];
    var lista = [d.join(' ')];
    if (d.length > 2) {
      var cola = d.slice(-2).join(' ');
      if (lista.indexOf(cola) === -1) lista.push(cola);
    }
    return lista;
  }

  /* La variante que de verdad interesa vender: la disponible mas cara.
     Devuelve null si el producto no sirve (ver trampa B de la cabecera). */
  function mejorVariante(producto) {
    var variantes = producto.variants || [];
    if (!variantes.length) return null;

    var mejorDisponible = null;
    var maxDeTodas = 0;
    variantes.forEach(function (v) {
      if (v.price > maxDeTodas) maxDeTodas = v.price;
      if (!v.available) return;
      if (mejorDisponible === null || v.price > mejorDisponible.price) mejorDisponible = v;
    });

    if (!mejorDisponible) return null;                       // agotado entero
    if (maxDeTodas >= UMBRAL_FRASCO && mejorDisponible.price < UMBRAL_FRASCO) {
      return null;   // el frasco esta agotado y solo queda la muestra
    }
    return mejorDisponible;
  }

  function tarjeta(producto, variante) {
    var art = document.createElement('div');
    art.className = 'nr-reco__tarjeta';

    var img = document.createElement('img');
    img.className = 'nr-reco__foto';
    img.loading = 'lazy';
    img.width = 64;
    img.height = 64;
    img.alt = producto.title;
    var foto = variante.featured_image || producto.featured_image || (producto.images && producto.images[0]);
    if (foto) {
      var url = typeof foto === 'string' ? foto : foto.src;
      if (url) img.src = url.split('?')[0] + '?width=160';
    }
    art.appendChild(img);

    var datos = document.createElement('div');
    datos.className = 'nr-reco__datos';

    var a = document.createElement('a');
    a.className = 'nr-reco__nombre';
    a.href = raiz + 'products/' + producto.handle + '?variant=' + variante.id;
    a.textContent = producto.title;
    datos.appendChild(a);

    if ((producto.variants || []).length > 1 && variante.title && variante.title !== 'Default Title') {
      var med = document.createElement('span');
      med.className = 'nr-reco__medida';
      med.textContent = variante.title;
      datos.appendChild(med);
    }

    var precio = document.createElement('span');
    precio.className = 'nr-reco__precio';
    precio.textContent = dinero(variante.price);
    if (variante.compare_at_price && variante.compare_at_price > variante.price) {
      var antes = document.createElement('span');
      antes.className = 'nr-reco__antes';
      antes.textContent = dinero(variante.compare_at_price);
      precio.appendChild(antes);
    }
    datos.appendChild(precio);
    art.appendChild(datos);

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'nr-reco__add';
    boton.textContent = 'Añadir';
    boton.addEventListener('click', function () { anadir(variante.id, boton); });
    art.appendChild(boton);

    return art;
  }

  function anadir(idVariante, boton) {
    boton.disabled = true;
    var textoPrevio = boton.textContent;
    boton.textContent = '...';

    fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: idVariante, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (datos) {
        if (datos.status) throw new Error(datos.description || 'no se pudo añadir');
        boton.textContent = '✓';
        boton.classList.add('nr-reco__add--hecho');
        refrescarCajon(datos.sections);
      })
      .catch(function () {
        boton.disabled = false;
        boton.textContent = textoPrevio;
      });
  }

  function refrescarCajon(secciones) {
    if (!secciones) return;
    try {
      var doc = new DOMParser();
      if (secciones['cart-drawer']) {
        var nuevo = doc.parseFromString(secciones['cart-drawer'], 'text/html').querySelector('cart-drawer');
        var actual = document.querySelector('cart-drawer');
        if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
      }
      if (secciones['cart-icon-bubble']) {
        var burbuja = doc.parseFromString(secciones['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        var destino = document.querySelector('#cart-icon-bubble');
        if (burbuja && destino) destino.innerHTML = burbuja.innerHTML;
      }
    } catch (e) { /* si falla el repintado, el carrito sigue correcto */ }

    document.dispatchEvent(new CustomEvent('nr:carrito-actualizado'));
    setTimeout(montar, 150);
  }

  function flechas(carril) {
    var izq = document.createElement('button');
    var der = document.createElement('button');
    [izq, der].forEach(function (b) { b.type = 'button'; b.className = 'nr-reco__flecha'; });
    izq.innerHTML = '&#8592;';
    der.innerHTML = '&#8594;';
    izq.setAttribute('aria-label', 'Anterior');
    der.setAttribute('aria-label', 'Siguiente');

    function paso() {
      var t = carril.querySelector('.nr-reco__tarjeta');
      return t ? t.getBoundingClientRect().width + 10 : 200;
    }
    izq.addEventListener('click', function () { carril.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    der.addEventListener('click', function () { carril.scrollBy({ left: paso(), behavior: 'smooth' }); });

    function estado() {
      izq.disabled = carril.scrollLeft <= 2;
      der.disabled = carril.scrollLeft >= carril.scrollWidth - carril.clientWidth - 2;
    }
    carril.addEventListener('scroll', estado);
    setTimeout(estado, 60);

    var caja = document.createElement('div');
    caja.className = 'nr-reco__flechas';
    caja.appendChild(izq);
    caja.appendChild(der);
    return caja;
  }

  function buscarHandles(consulta) {
    if (!consulta) return Promise.resolve([]);
    var u = raiz + 'search/suggest.json?q=' + encodeURIComponent(consulta) +
            '&resources[type]=product&resources[limit]=10';
    return fetch(u, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var lista = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        return lista.map(function (p) { return p.handle; });
      })
      .catch(function () { return []; });
  }

  function handlesDeColeccion() {
    return fetch(raiz + 'collections/' + COLECCION + '/products.json?limit=20', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return ((d && d.products) || []).map(function (p) { return p.handle; }); })
      .catch(function () { return []; });
  }

  /* Siempre por /products/<handle>.js: es el unico endpoint que devuelve el
     precio en centimos y la disponibilidad real de cada variante. */
  function ficha(handle) {
    return fetch(raiz + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function montar() {
    if (pintando) return;
    var pie = document.querySelector('cart-drawer .drawer__footer');
    if (!pie) return;
    pintando = true;

    var contexto = {};

    fetch(raiz + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        if (!carrito.items || !carrito.items.length) throw new Error('carrito vacio');

        /* 3-11-2026: aqui habia una regla que ESCONDIA el carrusel en movil
           cuando el carrito tenia 2 o mas lineas. Se puso el 29-10 porque el
           bloque del regalo de Halloween ocupaba 373 px del pie y no se veian
           los productos. Al quitar la promo ese bloque ya no esta, el pie
           vuelve a su tamano de siempre y esconder el carrusel solo seria
           perder venta cruzada. Se quita y se mide. */
        var firma = firmaDe(carrito);
        var yaPuesto = document.querySelector('cart-drawer .drawer__footer .nr-reco');
        if (yaPuesto) {
          if (yaPuesto.getAttribute('data-firma') === firma) throw new Error('ya esta al dia');
          yaPuesto.remove();
        }
        firmaActual = firma;

        contexto.enElCarrito = {};
        carrito.items.forEach(function (i) { contexto.enElCarrito[i.product_id] = true; });

        var principal = carrito.items.slice().sort(function (a, b) { return b.price - a.price; })[0];
        contexto.familia = familiaDe(principal.product_title);
        contexto.distintivos = distintivos(principal.product_title);
        contexto.semillaId = principal.product_id;

        var busquedas = consultas(principal.product_title).map(buscarHandles);
        return Promise.all(busquedas.concat([handlesDeColeccion()]));
      })
      .then(function (res) {
        var deColeccion = res[res.length - 1];
        var deFamilia = [];
        res.slice(0, -1).forEach(function (lista) {
          lista.forEach(function (h) { if (h && deFamilia.indexOf(h) === -1) deFamilia.push(h); });
        });

        contexto.esDeFamilia = {};
        deFamilia.forEach(function (h) { contexto.esDeFamilia[h] = true; });

        var orden = [];
        deFamilia.concat(deColeccion).forEach(function (h) {
          if (h && orden.indexOf(h) === -1) orden.push(h);
        });
        return Promise.all(orden.slice(0, MAX_CONSULTAS).map(ficha));
      })
      .then(function (fichas) {
        var candidatos = [];
        fichas.forEach(function (p) {
          if (!p || !p.handle) return;
          if (contexto.enElCarrito[p.id]) return;
          if (p.id === contexto.semillaId) return;
          var v = mejorVariante(p);
          if (!v) return;
          /* El buscador de Shopify devuelve cosas de mas: para "teriaq intense"
             se traia los CLUB DE NUIT INTENSE. Solo cuenta como familia si
             comparte al menos una palabra DISTINTIVA con lo que hay en el
             carrito. */
          var cuantas = comparten(contexto.distintivos, distintivos(p.title));
          var esFamilia = !!contexto.esDeFamilia[p.handle] && cuantas > 0;
          var esComplemento = esFamilia && RE_COMPLEMENTO.test(p.title);
          // 0 = complemento de la linea, 1 = perfume de la linea, 2 = top ventas
          var prioridad = esComplemento ? 0 : (esFamilia ? 1 : 2);
          candidatos.push({ producto: p, variante: v, prioridad: prioridad, parecido: cuantas });
        });

        if (!candidatos.length) throw new Error('nada que ofrecer');

        // orden estable: primero por prioridad, conservando el orden de entrada
        candidatos.forEach(function (c, i) { c.pos = i; });
        /* Dentro del mismo nivel manda el parecido: asi "PACK NOBLE BLUSH"
           (comparte noble + blush = 2) va por delante de "BADEE AL OUD
           SUBLIME" (comparte solo badee = 1). */
        candidatos.sort(function (a, b) {
          return a.prioridad - b.prioridad ||
                 b.parecido - a.parecido ||
                 a.pos - b.pos;
        });
        var elegidos = candidatos.slice(0, MAX_TARJETAS);

        var pie = document.querySelector('cart-drawer .drawer__footer');
        if (!pie) throw new Error('sin pie');

        var caja = document.createElement('div');
        caja.className = 'nr-reco';
        caja.setAttribute('data-firma', firmaActual);

        var carril = document.createElement('div');
        carril.className = 'nr-reco__carril';
        elegidos.forEach(function (c) { carril.appendChild(tarjeta(c.producto, c.variante)); });

        var cab = document.createElement('div');
        cab.className = 'nr-reco__cabecera';
        var h = document.createElement('h3');
        h.className = 'nr-reco__titulo';
        /* El titulo con el nombre de la linea funciona muy bien cuando la linea
           ES esa palabra: "Completa tu KHAMRAH", "Completa tu YARA". Pero en
           lineas de varias palabras queda ridiculo: "BADEE AL OUD NOBLE BLUSH"
           daba "Completa tu BADEE", que no le dice nada a nadie.
           Por eso solo se pone el nombre cuando el titulo del producto tiene
           una o dos palabras distintivas; si tiene mas, frase generica. */
        var hayFamilia = elegidos[0].prioridad < 2;
        if (hayFamilia && contexto.familia && contexto.distintivos.length <= 2) {
          h.textContent = 'Completa tu ' + contexto.familia;
        } else if (hayFamilia) {
          h.textContent = 'Lo que mejor combina';
        } else {
          h.textContent = 'Los más vendidos';
        }
        cab.appendChild(h);
        if (elegidos.length > 1) cab.appendChild(flechas(carril));

        caja.appendChild(cab);
        caja.appendChild(carril);

        /* Primero el carrusel y luego el atomizador: antes el perfume o el
           pack de 40-55 € y despues el complemento de 3,95 €, no al reves. */
        pie.insertBefore(caja, pie.firstChild);
      })
      .catch(function () { /* en silencio */ })
      .then(function () { pintando = false; });
  }

  function arrancar() {
    montar();
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#cart-icon-bubble, .cart-drawer__overlay, [name="add"], .product-form__submit')) {
        setTimeout(montar, 900);
      }
    }, true);
    document.addEventListener('nr:carrito-actualizado', function () { setTimeout(montar, 150); });

    var d = document.querySelector('cart-drawer');
    if (d && window.MutationObserver) {
      new MutationObserver(function () { setTimeout(montar, 120); })
        .observe(d, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
